import {isChooseSeatNoFee} from '../../../../../selectors/navigation'
import {getShowPricingOptionsPlace} from '../../../../../selectors/seating/mode'
import {connect} from '../../../../runtime-context/context'
import {TablePricingOptionModalRuntimeProps} from './interfaces'
import {TablePricingOptionsModal as Presentation} from './table-pricing-options-modal'

const mapRuntime = ({
  state,
  actions: {setShowPricingOptionsPlace, selectPlacePricingOption},
}): TablePricingOptionModalRuntimeProps => ({
  place: getShowPricingOptionsPlace(state),
  event: state.event,
  setShowPricingOptionsPlace,
  selectPlacePricingOption,
  noServiceFee: isChooseSeatNoFee(state),
})

export const TablePricingOptionsModal = connect<{}, TablePricingOptionModalRuntimeProps>(mapRuntime)(Presentation)
